import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { CasinoTheme } from '@frontend/casino-ui/shared';

import { PillItemComponent } from '../pill-item.component';
import { ICategory, PillSubNavConfig } from '../pills-sub-navigation.model';

@Component({
    selector: 'cc-category-navigation',
    standalone: true,
    imports: [PillItemComponent],
    templateUrl: './category-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryNavigationComponent {
    config = input<PillSubNavConfig>({} as PillSubNavConfig);
    navItems = input<ICategory[]>([]);
    processedMyNavCategories = input<ICategory[]>([]);
    defaultCategoryType = input<ICategory>({} as ICategory);
    currentTheme = input<CasinoTheme>('bwin');

    readonly extentRightMenuTracking = output<{ url: string; categoryid: string }>();
    readonly setActiveMobile = output<string>();
    readonly categoryTracking = output<{ event: Event; index: number; categoryid: string }>();

    isHidden(categoryid: string): boolean {
        return (
            this.defaultCategoryType() &&
            this.defaultCategoryType().categoryid === categoryid &&
            this.config().hideHomeInSubNav &&
            this.config().isTouch
        );
    }

    isSelected(category: ICategory): boolean {
        return this.config().categoryType === category.categoryid || (this.config().currentUrl === category.url && category.fromExtendedMenuRight);
    }

    private handleSetActiveMobile(categoryId: string): void {
        this.setActiveMobile.emit(categoryId);
    }

    handleCategoryTracking(event: Event, index: number, categoryid: string): void {
        this.categoryTracking.emit({ event, index, categoryid });
    }

    handleExtentRightMenuTracking(url: string, categoryid: string): void {
        this.extentRightMenuTracking.emit({ url, categoryid });
    }

    onPillClick(category: ICategory, $event: Event): void {
        if (category.isNavigationCategory) {
            this.handleSetActiveMobile(category.categoryid);
            this.handleCategoryTracking($event, category.index, category.categoryid);
        } else if (category.isExtendedTopMenuItem) {
            this.handleExtentRightMenuTracking(category.url, category.categoryid);
        }
    }

    private isDiscoverSticker(categoryid: string): boolean {
        return this.config().discoverFeedLmtkey === categoryid && this.config().displayDiscoverSticker;
    }

    protected isBadgeTypeSignPosting(signPostingCount: number): boolean {
        return this.config().isSignPosting && signPostingCount > 0;
    }

    protected isBadgeTypeIcon(categoryid: string): boolean {
        return this.isDiscoverSticker(categoryid) && this.config().isBadgeTypeIcon;
    }

    protected isBadgeTypeText(categoryid: string): boolean {
        return this.isDiscoverSticker(categoryid) && this.config().isBadgeTypeText;
    }
}
